import React from 'react';
import styles from '../../pages/login/LoginPage.module.scss';
import easternexchange from './Img/logo-ee-wide.png';
// import easternexchange from './Img/white-bg.jpg';
import middlelogo from './Img/middle-logo.png';
import canerabank from './Img/canera-bank.svg';
import { Copyright } from '../copyright/copyright';

function SideBanner() {
  return (
    <div className={styles.LoginPage__artwork}>
      <div className={styles.LoginPage__logos}>
      </div>
    </div>
  );
}
export default SideBanner;
